import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Collapse from 'react-collapse';
import { SideBarMenu } from 'features/login/interface/login.interface';

interface Props {
	menu: SideBarMenu;
	isOpen: boolean;
	renderSideNav: () => void;
	toggleIsOpen: (name: string) => void;
}

const getPathElements = (path: string) => {
	return path.split('/').filter((str) => str !== '');
};

const getActiveClass = (currentPathStr: string, actualPathStr: string): string => {
	// for base path, it's compulsary to have both path as `/`, in order to show `active` status
	if (actualPathStr === '/') {
		if (currentPathStr === actualPathStr) {
			return 'active';
		}
		return '';
	}
	const actualPath = getPathElements(actualPathStr);
	const currentPath = getPathElements(currentPathStr);
	// if the first level path matches for actual path, and current path, return `active`
	if (actualPath[0] === currentPath[0]) {
		return 'active';
	}
	return '';
};

const getSubActiveClass = (currentPathStr: string, actualPathStr: string): string => {
	const actualPath = getPathElements(actualPathStr);
	const currentPath = getPathElements(currentPathStr);
	if (
		(currentPathStr.includes('/organizations/list') || currentPathStr.includes('/organizations/payment-status')) &&
		actualPathStr.includes('/organizations/license')
	) {
		return 'active';
	}
	// for sub menu to be active, first and second level path must match
	if (actualPath[0] === currentPath[0] && actualPath[1] === currentPath[1]) {
		return 'active';
	}
	return '';
};

const icons: { [key: string]: string } = {
	media: 'picture-o',
	money: 'money',
	users: 'users',
	events: 'calendar',
	poll: 'bar-chart',
	shop: 'shopping-bag',
	streamer: 'id-card',
	list: 'list',
	link: 'link',
	sort: 'sort',
	earlyAccess: 'universal-access',
	chat: 'comments',
	magic: 'magic',
	userSecret: 'user-secret',
	ban: 'ban',
	setting: 'cog',
	transaction: 'money',
	fanTransaction: 'money',
	addBonus: 'money',
	dashboard: 'dashboard',
	smsPackage: 'shopping-bag',
	phone: 'phone',
	userValue: 'address-card'
};

const NavItem: React.FC<Props> = (props) => {
	const location = useLocation();
	const className = getActiveClass(location.pathname, props.menu.route);
	const handleNavClick = () => {
		props.renderSideNav();
		props.toggleIsOpen(props.menu.name);
	};

	return props.menu.children ? (
		<li className={className} onClick={handleNavClick}>
			<Link to={'#'}>
				<i className={`fa fa-${icons[props.menu.icon]}`} />
				<span className="nav-label">{props.menu.name}</span>
				<span className="float-right">
					<i className={`${!!className || props.isOpen ? 'fa fa-chevron-down' : 'fa fa-chevron-right'}`} />
				</span>
			</Link>
			<div className="mini-navbar-links-wrapper">
				<ul className="nav nav-second-level">
					{props.menu.children.map((child) => (
						<li key={child.url} className={getSubActiveClass(location.pathname, child.url)}>
							<Link to={child.url} className="nav-label">
								{child.name}
							</Link>
						</li>
					))}
				</ul>
			</div>

			<Collapse.Collapse
				className={`${className === 'active' && 'collapse-active'}`}
				isOpened={!!className || props.isOpen}
			>
				<ul className="nav nav-second-level collapse in">
					{props.menu.children.map((child) => (
						<li key={child.url} className={getSubActiveClass(location.pathname, child.url)}>
							<Link to={child.url} className="nav-label">
								{child.name}
							</Link>
						</li>
					))}
				</ul>
			</Collapse.Collapse>
		</li>
	) : (
		<li className={className} onClick={handleNavClick}>
			<Link to={props.menu.route}>
				<i className={`fa fa-${icons[props.menu.icon]}`} />
				<span className="nav-label">{props.menu.name}</span>
			</Link>
		</li>
	);
};

export default NavItem;
